import { render } from "./foot.vue?vue&type=template&id=577aad77"
import script from "./foot.vue?vue&type=script&lang=js"
export * from "./foot.vue?vue&type=script&lang=js"

import "./foot.vue?vue&type=style&index=0&id=577aad77&lang=scss"

import exportComponent from "/usr/src/app/frontend_result/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__